export default function ArrowIcon(props) {
  return (
    <svg width={props.width ?? "9"} height={props.height ?? "12"} viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-7.21107e-08 1.3536L5.1525 5.76L-5.41597e-07 10.1664L1.58625 11.52L8.33625 5.76L1.58625 5.67024e-08L-7.21107e-08 1.3536Z" fill={props.fill ?? "#8AFCFD"} />
    </svg>
  )
}
